import DefaultPageLayout from './default'
import CategoryListing from './category-listing'

const layouts = {
  default: DefaultPageLayout,
  categoryListing: CategoryListing,
}

export { DefaultPageLayout }

export const getLayout = (layout, def = DefaultPageLayout) => layouts[layout] || def
export default getLayout
